import { render, staticRenderFns } from "./plugins.vue?vue&type=template&id=6d19a3fc&scoped=true&"
import script from "./plugins.vue?vue&type=script&lang=js&"
export * from "./plugins.vue?vue&type=script&lang=js&"
import style0 from "./plugins.vue?vue&type=style&index=0&id=6d19a3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19a3fc",
  null
  
)

export default component.exports